// extracted by mini-css-extract-plugin
export default {"route":"RouteButton_route__ilGIO","icon":"RouteButton_icon__bHDHO","iconOnly":"RouteButton_iconOnly__SAIBc"};